module.exports = __webpack_public_path__ + "img/sub.e4e3218d.png";